import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-background via-muted/30 to-accent/10 pt-24 pb-16">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent-foreground px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Calendar" size={16} />
            <span>Ready to Start Your Project?</span>
          </div>

          <h1 className="text-fluid-5xl font-display font-bold text-primary mb-6 text-balance">
            Let's Create Something
            <span className="text-accent block">Extraordinary Together</span>
          </h1>

          <p className="text-fluid-lg text-muted-foreground mb-8 max-w-2xl mx-auto text-pretty">
            Whether you're planning a wedding, showcasing real estate, launching
            a brand campaign, or exploring design fiction, we're here to bring
            your vision to life with cinematic excellence.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              variant="default"
              size="lg"
              className="bg-cta hover:bg-cta/90 text-cta-foreground"
              iconName="Calendar"
              iconPosition="left"
            >
              Book Free Consultation
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
            >
              Call Now: (508) 980-5187
            </Button>
          </div>

          <div className="flex items-center justify-center space-x-8 mt-12 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} />
              <span>Response within 2 hours</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} />
              <span>Free consultation</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Award" size={16} />
              <span>Award-winning team</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
